import { type ActionSetBadgeCounts, type BadgeCounts, SET_BADGE_COUNTS } from '~shared/actions/notices';

export type StateNotices = {
  badgeCounts: BadgeCounts;
};

export const initialState: StateNotices = {
  badgeCounts: {
    messages: 0,
    patientTasks: 0,
  },
};

type Action = ActionSetBadgeCounts;

export default (state: StateNotices = initialState, action: Action): StateNotices => {
  /**
   * This reducer's state is persisted in local storage, so merge
   * current state with initial to handle the later addition of any
   * new state keys.
   */
  state = { ...initialState, ...state };
  state.badgeCounts = { ...initialState.badgeCounts, ...state.badgeCounts };

  const { type } = action;

  switch (type) {
    case SET_BADGE_COUNTS: {
      const { payload } = action;
      return { ...state, badgeCounts: { ...state.badgeCounts, ...payload } };
    }

    default:
      return state;
  }
};
